import Price from "../price/price";
import AddToCart from "../addToCart/addToCart";

import Card from 'react-bootstrap/Card';

function Product({ product }) {

    const { sku, name, price, imageUrl, hideAddToCart} = product;

    return (
        <Card style={{ width: '18rem' }}>
            <Card.Img variant="top" src={imageUrl} />
            <Card.Body>
                <Card.Title>{name}</Card.Title>
                <Card.Text>
                    SKU: {sku} <br />
                    <Price value={price} currency={"GBP"} />
                </Card.Text>
                {!hideAddToCart && <AddToCart product={product} />}
            </Card.Body>
        </Card>
    );
}

export default Product;
